(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["er-fty-hub"] && !Shopify.designMode) return;
  try {
    
/* Plays the hero video only while it is on screen and the tab is visible, and
   never for visitors who asked for less motion or a lighter page: those
   download nothing (preload stays "none"). The pause button appears only once
   playback is allowed; a visitor's own pause is kept until they press play. */
if (!customElements.get('er-fty-video')) {
  customElements.define('er-fty-video', class extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      const toggle = this.querySelector('[data-fty-toggle]');
      const conn = navigator.connection;
      if (!video || matchMedia('(prefers-reduced-motion: reduce)').matches || (conn && conn.saveData)) return;
      let inView = false;
      let userPaused = false;
      const sync = () => {
        if (inView && !userPaused && !document.hidden) {
          video.preload = 'metadata';
          const attempt = video.play();
          if (attempt) attempt.catch(() => setPaused(true));
        } else {
          video.pause();
        }
      };
      const setPaused = (paused) => {
        if (!toggle) return;
        toggle.classList.toggle('is-paused', paused);
        toggle.setAttribute('aria-label', paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
      };
      /* The button shows only once the video really plays, so it never offers
         "Pause" over a clip the browser refused to autoplay. */
      video.addEventListener('playing', () => {
        video.classList.add('is-playing');
        if (toggle) toggle.hidden = false;
        if (!userPaused) setPaused(false);
      });
      if (toggle) {
        toggle.addEventListener('click', () => {
          userPaused = !userPaused;
          setPaused(userPaused);
          sync();
        });
      }
      this.onVisibility = sync;
      document.addEventListener('visibilitychange', this.onVisibility);
      this.observer = new IntersectionObserver((entries) => {
        inView = entries[entries.length - 1].isIntersecting;
        sync();
      });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-header"] && !Shopify.designMode) return;
  try {
    
class ErHeader extends HTMLElement {
  connectedCallback() {
    this.shrinkAfter = Number(this.dataset.shrinkAfter) || 40;
    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.syncShrunk();
    // Publish the announcement bar's REAL height, because the token is a
    // one-line composition and the bar wraps to two lines at 360px with the
    // shipped default string. The token stays as the fallback for no-JS and
    // for the frames before this runs.
    // Scoped to er-announcement--top (27/09/2026, homepage strip change): on
    // the home page the top bar renders nothing and the ONLY .er-announcement
    // in the DOM would otherwise be the strip under the hero, which must
    // never be measured into this offset.
    // The fragrance story pages also render no top bar (28/09/2026).
    const notice = document.querySelector('.er-announcement--top');
    if (notice && window.ResizeObserver) {
      const sync = () => {
        // A bar that is not rendered reads 0, and writing that would pull the
        // header up over the bar for a frame if it comes back.
        // Fractional, like the inline script above: offsetHeight rounds the
        // 37.2px bar to 37 and leaves the header 0.2px over it.
        const height = notice.getBoundingClientRect().height;
        if (height) {
          document.documentElement.style.setProperty('--er-notice-measured', +height.toFixed(2) + 'px');
        }
      };
      this.noticeObserver = new ResizeObserver(sync);
      this.noticeObserver.observe(notice);
      sync();
    }
    // The panels open from CSS (:hover and :focus-within on the wrapper) and the
    // trigger stays a real link to its page, so the only thing missing for
    // assistive technology is the disclosure STATE. aria-expanded is set here,
    // never in the Liquid, so without JavaScript the link is a plain link rather
    // than one announcing a state nothing maintains. The state is read from the
    // same selectors the stylesheet reads, so the two cannot drift: a wrapper is
    // engaged when the pointer or focus is inside it, Escape adds is-dismissed,
    // and the cut rules above hide EVERY panel when two wrappers are engaged at
    // once (pointer on one trigger, focus in another), so only a lone engaged
    // wrapper is open. Each input syncs twice, at once and on a zero-delay
    // timer, because :hover and :focus-within update around the event, not
    // reliably before it.
    this.wraps = [...this.querySelectorAll('.er-header__shopwrap, .er-header__megawrap')].map((wrap) => ({
      wrap,
      trigger: wrap.querySelector('.er-header__link'),
    }));
    const engaged = (w) => w.wrap.matches(':hover') || w.wrap.matches(':focus-within');
    const syncExpanded = () => {
      const open = this.wraps.filter(engaged);
      this.wraps.forEach((w) => {
        const isOpen = open.length === 1 && open[0] === w && !w.wrap.classList.contains('is-dismissed');
        w.trigger.setAttribute('aria-expanded', String(isOpen));
      });
    };
    const resync = () => {
      syncExpanded();
      setTimeout(syncExpanded, 0);
    };
    // Escape must close a panel the POINTER opened as well as one focus opened
    // (WCAG 2.2 SC 1.4.13), and a keydown with focus on the body never reaches
    // this element, so the listener lives on the document. Focus moves to the
    // trigger only when it was already inside the wrapper: dismissing a hover
    // panel must not move focus.
    this.onEscape = (event) => {
      if (event.key !== 'Escape') return;
      this.wraps.forEach((w) => {
        if (!engaged(w)) return;
        w.wrap.classList.add('is-dismissed');
        if (w.wrap.contains(document.activeElement)) w.trigger.focus();
      });
      resync();
    };
    document.addEventListener('keydown', this.onEscape);
    this.wraps.forEach((w) => {
      w.wrap.addEventListener('pointerenter', () => {
        w.wrap.classList.remove('is-dismissed');
        resync();
      });
      w.wrap.addEventListener('pointerleave', resync);
      w.wrap.addEventListener('focusin', resync);
      w.wrap.addEventListener('focusout', (event) => {
        if (!w.wrap.contains(event.relatedTarget)) w.wrap.classList.remove('is-dismissed');
        resync();
      });
    });
    syncExpanded();
  }
  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    if (this.onEscape) document.removeEventListener('keydown', this.onEscape);
    if (this.noticeObserver) this.noticeObserver.disconnect();
  }
  // Hysteresis: it takes the full threshold to shrink and a return to half of
  // it to grow back, so a scroll resting on the boundary cannot flicker the
  // background and the type inversion on and off.
  syncShrunk() {
    const shrunk = this.classList.contains('is-shrunk');
    this.classList.toggle('is-shrunk', window.scrollY > (shrunk ? this.shrinkAfter / 2 : this.shrinkAfter));
  }
  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.syncShrunk();
      this.ticking = false;
    });
  }
}
customElements.define('er-header', ErHeader);

class ErMobileMenu extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('.er-mobmenu');
    // Every opener (the header button and the floating pill's Menu button).
    this.openers = Array.from(document.querySelectorAll('[aria-controls="erMobileMenu"]'));
    this.opener = null;
    this.closer = this.querySelector('.er-mobmenu__close');
    if (!this.panel || !this.openers.length) return;
    this.openers.forEach((opener) => opener.addEventListener('click', () => this.open(opener)));
    this.closer.addEventListener('click', () => this.close());
    // Every accordion, not the first one. This was querySelector on both
    // selectors, which was correct while exactly one group existed. There are
    // two now (Shop by Product and Shop by Fragrance), and a singular binding
    // would have left the second group's button inert with its list hidden for
    // ever: no error, nothing to see in a static check, and invisible on
    // desktop where the drawer never opens.
    this.shopGroups = Array.from(this.querySelectorAll('.er-mobmenu__shopgroup'))
      .map((group) => ({
        toggle: group.querySelector('.er-mobmenu__shoptoggle'),
        list: group.querySelector('.er-mobmenu__shoplist'),
      }))
      .filter((group) => group.toggle && group.list);
    this.shopGroups.forEach((group) => {
      group.toggle.addEventListener('click', () => {
        const expanded = group.toggle.getAttribute('aria-expanded') === 'true';
        group.toggle.setAttribute('aria-expanded', String(!expanded));
        group.list.hidden = expanded;
      });
      // Same-page navigations would otherwise leave the drawer open with scroll locked.
      group.list.addEventListener('click', (event) => {
        if (event.target.closest('a')) this.close();
      });
    });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
      if (event.key === 'Tab') this.trapFocus(event);
    });
  }
  open(opener) {
    this.opener = opener || this.openers[0];
    this.panel.hidden = false;
    this.openers.forEach((el) => el.setAttribute('aria-expanded', 'true'));
    document.documentElement.style.overflow = 'hidden';
    this.closer.focus();
    document.dispatchEvent(new CustomEvent('er:drawer:open'));
  }
  close() {
    this.panel.hidden = true;
    this.openers.forEach((el) => el.setAttribute('aria-expanded', 'false'));
    document.documentElement.style.overflow = '';
    (this.shopGroups || []).forEach((group) => {
      group.toggle.setAttribute('aria-expanded', 'false');
      group.list.hidden = true;
    });
    // The opener that was used. If it is the pill's Menu button, the pill
    // re-shows itself on er:drawer:close (focus is already on it by then).
    if (this.opener) this.opener.focus();
    document.dispatchEvent(new CustomEvent('er:drawer:close'));
  }
  trapFocus(event) {
    const focusables = this.panel.querySelectorAll('a[href], button');
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}
customElements.define('er-mobile-menu', ErMobileMenu);

// Minimum upward scroll, in px, before the pill shows (ignores jitter).
const SCROLL_UP_MIN = 8;

class ErFloatingNav extends HTMLElement {
  connectedCallback() {
    this.pill = this.querySelector('.er-floatnav');
    if (!this.pill) return;
    this.links = Array.from(this.pill.querySelectorAll('a, button'));
    this.phone = window.matchMedia('(max-width: 1023px)');
    this.lastY = window.scrollY;
    this.visible = false;
    this.ticking = false;
    this.keyboardModality = false;
    this.openDrawers = new Set();
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    // Keyboard modality is bidirectional: Tab enters it, pointer activity leaves it,
    // so the pill returns for a user who switches back to the mouse.
    window.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        this.keyboardModality = true;
        this.hide();
      }
    });
    window.addEventListener('pointerdown', () => { this.keyboardModality = false; });
    // Two emitters: the mobile menu (er:drawer:*) and the cart drawer (er:cart:*,
    // which bubbles to document). Tracked by source so a stray close cannot
    // clear the other drawer's state.
    [['er:drawer:open', 'er:drawer:close', 'menu'], ['er:cart:open', 'er:cart:close', 'cart']].forEach(([open, close, source]) => {
      document.addEventListener(open, () => {
        this.openDrawers.add(source);
        this.hide();
      });
      document.addEventListener(close, () => {
        this.openDrawers.delete(source);
        // Both components focus the opener before dispatching close. If that was
        // a pill control, bring the pill back so focus is not on a hidden element.
        if (!this.openDrawers.size && this.pill.contains(document.activeElement)) this.show();
      });
    });
  }
  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }
  get suppressed() {
    return this.keyboardModality || this.openDrawers.size > 0;
  }
  // Phones: the header and the top announcement notice have both left the screen.
  headerGone() {
    const gone = (el) => !el || el.getBoundingClientRect().bottom <= 0;
    return gone(document.getElementById('erHeader')) && gone(document.querySelector('.er-announcement--top'));
  }
  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      const y = window.scrollY;
      const past = this.phone.matches ? this.headerGone() : y > window.innerHeight * 1.5;
      const d = y - this.lastY;
      if (this.suppressed || !past) {
        // A keyboard user focused in the pill keeps it visible; their next Tab hides it via the keydown path.
        if (!(this.keyboardModality && this.pill.contains(document.activeElement))) this.hide(true);
        this.lastY = y;
      } else if (d > 0) {
        this.hide(true);
        this.lastY = y;
      } else if (-d >= SCROLL_UP_MIN) {
        this.show();
        this.lastY = y;
      }
      // A small upward step keeps the anchor, so steps add up to SCROLL_UP_MIN.
      this.ticking = false;
    });
  }
  show() {
    if (this.visible) return;
    this.visible = true;
    this.pill.classList.add('is-visible');
    this.pill.setAttribute('aria-hidden', 'false');
    this.links.forEach((a) => a.removeAttribute('tabindex'));
  }
  hide(moveFocus) {
    if (!this.visible) return;
    this.visible = false;
    // Scroll path only: do not strand focus on a control leaving the accessibility
    // tree. The Tab path needs no move; the browser's Tab carries on from here.
    if (moveFocus && this.pill.contains(document.activeElement)) {
      const main = document.getElementById('MainContent');
      if (main) main.focus({ preventScroll: true }); else document.activeElement.blur();
    }
    this.pill.classList.remove('is-visible');
    this.pill.setAttribute('aria-hidden', 'true');
    this.links.forEach((a) => a.setAttribute('tabindex', '-1'));
  }
}
customElements.define('er-floating-nav', ErFloatingNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-hero"] && !Shopify.designMode) return;
  try {
    
class ErHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.er-hero__slide'));
    this.dots = Array.from(this.querySelectorAll('.er-hero__dot'));
    this.index = 0;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.interval = Number(this.dataset.autoplay) || 0;
    // Video is owned here, not by an autoplay attribute, so one place decides
    // when motion is allowed: not under reduced motion, not on a saveData
    // connection, not while the tab is hidden, not while the visitor has
    // pressed pause. The poster is what everyone else sees.
    this.videos = this.slides.map((slide) => slide.querySelector('[data-hero-video]'));
    this.videoAllowed = !this.reduced && !(navigator.connection && navigator.connection.saveData);
    this.entered = Date.now();
    this.videos.forEach((video) => {
      if (!video) return;
      video.addEventListener('playing', () => video.classList.add('is-playing'));
      // A failed source fires error on the <source>, not on <video>. Drop the
      // element so the poster underneath is all that remains.
      const source = video.querySelector('source');
      if (source) {
        source.addEventListener('error', () => {
          video.remove();
          this.syncToggle();
          // If this slide was being held for its clip, stop waiting for it.
          if (this.holdVideo === video && this.timer) this.start();
        });
      }
    });
    this.onVisibility = () => (document.hidden ? this.pauseVideo(false) : this.playVideo());
    document.addEventListener('visibilitychange', this.onVisibility);
    this.playVideo();
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.go(Number(dot.dataset.heroDot));
        // Choosing a slide is an explicit intent to stay on it, so route through
        // setPaused rather than stopping quietly, keeping the toggle honest.
        this.setPaused(true);
      });
    });
    this.autoplays = this.interval > 0 && this.slides.length > 1 && !this.reduced;
    this.toggle = this.querySelector('[data-hero-toggle]');
    if (this.autoplays) {
      // Pause while the visitor is hovering or has focus inside, so a slide
      // never advances under someone reading or reaching for its link.
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.resume());
      // Hover and focus do not exist on a touch screen, so WCAG 2.2.2 needs an
      // explicit control.
      this.start();
    }
    // The toggle stops the carousel and/or the video, so it is revealed when
    // either will actually run. A video loops for ever (WCAG 2.2.2), so it
    // needs a control even with one slide or autoplay off.
    if (this.toggle) {
      this.syncToggle();
      // Read the state the visitor can SEE, not userPaused: the editor's
      // block:select stops the timer and marks the toggle without claiming a
      // user pause, and reading the flag there would spend the first click
      // repeating the state the button is already showing.
      this.toggle.addEventListener('click', () => this.setPaused(!this.toggle.classList.contains('is-paused')));
    }
    // The theme editor renders every slide but only one is visible, so selecting
    // slide 2, 3 or 4 in the sidebar would otherwise keep showing slide 1 and
    // Sadie could not judge the shade she is setting.
    this.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('.er-hero__slide');
      if (!slide) return;
      // Stop the CAROUSEL, not the video. setPaused would set userPaused, which
      // playVideo returns early on, so one click in the sidebar killed the video
      // for the rest of the editing session and Sadie could not judge the clip
      // she was setting. The toggle is updated the way setPaused updates it, so
      // the control still tells the truth about the stopped timer.
      this.stop();
      if (this.toggle) {
        this.toggle.classList.add('is-paused');
        this.toggle.setAttribute('aria-label', this.toggle.dataset.labelPlay);
      }
      this.go(this.slides.indexOf(slide));
      this.playVideo();
    });
  }
  // Shown only while it controls something: the carousel, or a video that is
  // still on the page (a failed clip is removed).
  syncToggle() {
    if (!this.toggle) return;
    this.toggle.hidden = !(this.autoplays || (this.videoAllowed && this.videos.some((v) => v && v.isConnected)));
  }
  // Crossfade length in ms, read from the active slide's computed transition
  // (always in seconds), because the custom property is served minified as
  // `.25s` and not `250ms`. First of a comma list.
  fadeMs() {
    const first = getComputedStyle(this.slides[this.index]).transitionDuration.split(',')[0].trim();
    const n = parseFloat(first) || 0;
    return first.endsWith('ms') ? n : n * 1000;
  }
  setPaused(paused) {
    this.userPaused = paused;
    if (!paused) this.entered = Date.now();
    if (paused) {
      this.pauseVideo(false);
    } else {
      this.playVideo();
    }
    if (paused) {
      this.stop();
    } else {
      this.start();
    }
    if (this.toggle) {
      this.toggle.classList.toggle('is-paused', paused);
      this.toggle.setAttribute('aria-label', this.toggle.dataset[paused ? 'labelPlay' : 'labelPause']);
    }
  }
  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibility);
  }
  go(next) {
    if (next === this.index || !this.slides[next]) return;
    // inert BLOCKS focus entering a subtree; it does not evict focus already
    // there. Without this, focus left on a CTA when the slide turns over sits
    // on a link that is now removed from the accessibility tree, which is the
    // very defect inert is here to close, and axe cannot see it.
    const keptFocus = this.slides[this.index].contains(document.activeElement);
    this.slides[this.index].classList.remove('is-active');
    this.slides[this.index].setAttribute('aria-hidden', 'true');
    this.slides[this.index].setAttribute('inert', '');
    if (this.dots[this.index]) {
      this.dots[this.index].classList.remove('is-active');
      this.dots[this.index].removeAttribute('aria-current');
    }
    // Pause without rewinding: the outgoing slide is still visible through the
    // crossfade, and frame 0 of a clip can be black. It rewinds on re-entry.
    this.pauseVideo(false);
    this.index = next;
    this.entered = Date.now();
    this.slides[this.index].classList.add('is-active');
    this.slides[this.index].removeAttribute('aria-hidden');
    this.slides[this.index].removeAttribute('inert');
    this.playVideo(true);
    if (keptFocus) {
      // Move to the incoming slide's own control rather than blurring to body,
      // which would dump a keyboard user back at the top of the page.
      const landing = this.slides[this.index].querySelector('a[href], button:not([disabled])');
      if (landing) landing.focus();
    }
    if (this.dots[this.index]) {
      this.dots[this.index].classList.add('is-active');
      this.dots[this.index].setAttribute('aria-current', 'true');
    }
  }
  start() {
    // Guard against a second timer: setPaused(false) and resume() can both land
    // here, and a duplicate interval would double the advance rate.
    this.stop();
    if (this.autoplays) this.arm();
  }
  next() {
    this.stop();
    this.go((this.index + 1) % this.slides.length);
    this.arm();
  }
  // One timer per slide, armed at the normal interval first. A video that is
  // actually PLAYING (the `playing` event, not play() returning, which says
  // nothing about data) then extends the hold to the longer of the interval and
  // one play of the clip, ending as the crossfade begins. A clip that never
  // starts, or is SHORTER THAN the interval as a whole, leaves the interval in
  // charge. Otherwise the slide turns at remaining time minus the fade, even
  // when that is less than the interval, so a clip resumed late does not wrap.
  // ponytail: cap of 30 seconds measured from slide entry so a long clip cannot
  // keep the carousel up for ever; raise it only if clips longer than that ship.
  arm() {
    this.timer = setTimeout(() => this.next(), this.interval * 1000);
    const video = this.videos[this.index];
    if (!video || !video.isConnected || !this.videoAllowed || this.userPaused || document.hidden) return;
    const hold = () => {
      if (!isFinite(video.duration) || video.duration * 1000 <= this.interval * 1000) return;
      const left = (video.duration - video.currentTime) * 1000 - this.fadeMs();
      const room = 30000 - (Date.now() - this.entered);
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.next(), Math.max(0, Math.min(left, room)));
    };
    this.holdVideo = video;
    this.holdListener = () => {
      video.removeEventListener('playing', this.holdListener);
      hold();
    };
    video.addEventListener('playing', this.holdListener);
    if (!video.paused && video.readyState >= 3) this.holdListener();
  }
  resume() {
    // The toggle showing Play is a pause too: block:select stops the carousel
    // and marks the button without setting userPaused, so without this the next
    // mouseleave would restart it under a Play label.
    if (this.toggle && this.toggle.classList.contains('is-paused')) return;
    // The focus half of the pause was declared in connectedCallback and never
    // enforced here: mouseleave called resume() while focus was still inside,
    // so a slide DID advance under someone reaching for its link.
    if (this.contains(document.activeElement)) return;
    if (this.autoplays && !this.userPaused && !this.timer) {
      this.entered = Date.now();
      this.start();
    }
  }
  stop() {
    if (this.timer) clearTimeout(this.timer);
    this.timer = null;
    if (this.holdVideo) this.holdVideo.removeEventListener('playing', this.holdListener);
    this.holdVideo = null;
  }
  playVideo(rewind) {
    const video = this.videos[this.index];
    if (!video || !video.isConnected) return;
    // Rewind before the paused/hidden guard, so a slide entered while paused or
    // hidden does not later resume from a stale position. A rewound clip hides
    // again until it actually plays, so frame 0 never sits over the cover.
    if (rewind) {
      if (video.currentTime > 0) video.currentTime = 0;
      video.classList.remove('is-playing');
    }
    if (!this.videoAllowed || this.userPaused || document.hidden) return;
    // play() rejects when the browser declines (no user gesture policy for
    // unmuted, or a decode failure). The poster is already on screen.
    // A refused play must not leave the slide waiting on a clip that never runs.
    video.play().catch(() => {
      if (this.holdVideo === video && this.timer) this.start();
    });
  }
  pauseVideo() {
    const video = this.videos[this.index];
    if (!video || !video.isConnected) return;
    video.pause();
  }
}
customElements.define('er-hero', ErHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-newsletter"] && !Shopify.designMode) return;
  try {
    
class ErNewsletter extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[type="email"]');
    this.button = this.querySelector('button[type="submit"]');
    this.status = this.querySelector('.er-news__status');
    if (!this.form) return;
    this.form.addEventListener('submit', (event) => this.onSubmit(event));
  }
  show(message, ok) {
    this.status.textContent = message;
    this.status.className = 'er-news__status ' + (ok ? 'er-news__success' : 'er-news__error');
  }
  async onSubmit(event) {
    // The submit event only fires once the browser has validated required and
    // the email format, so the address here is well formed.
    event.preventDefault();
    const email = (this.input.value || '').trim();
    const company = this.dataset.company;
    const list = this.dataset.list;
    if (!email || !company || !list) { this.show(this.dataset.error, false); return; }
    this.button.disabled = true;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    try {
      const res = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
        signal: controller.signal,
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Website newsletter',
              profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      });
      clearTimeout(timer);
      if (res.status === 202) {
        this.form.hidden = true;
        this.show(this.dataset.success, true);
        // Move focus to the status so a keyboard user is not dropped to the top
        // of the page when the form is hidden, and the message is read out.
        this.status.focus();
        this.dispatchEvent(new CustomEvent('er:newsletter:subscribed', { bubbles: true }));
      } else {
        this.button.disabled = false;
        this.show(this.dataset.error, false);
      }
    } catch (error) {
      clearTimeout(timer);
      this.button.disabled = false;
      this.show(this.dataset.error, false);
    }
  }
}
customElements.define('er-newsletter', ErNewsletter);

  } catch(e) { console.error(e); }
})();
})();
